import { firestore } from "vue-app-utils-web";
import dbFns from "@/db-functions";

const db = firestore();

export { db, dbFns };